export const copyMixins = {
  methods: {
    // 复制订单
    copyOrder(row) {
      console.log(row);
      if (row.orderType == "TIMELY") {
        let areaCode = [];
        let pickupAreaCode = [];
        this.$fetch(`/order/api/order/${row.id}`).then((res) => {
          if (res.code == 0) {
            let item = res.data;
            let orderItems = item.orderItems.map((i) => {
              let fileList = [
                {
                  name: i.name,
                  status: "done",
                  uid: "-1",
                  thumbUrl: i.imgUrl,
                  response: { data: { url: i.imgUrl } },
                },
              ];
              return {
                count: i.count,
                description: "",
                goodsTypeId: i.goodsTypeId,
                name: i.name,
                packingMethod: i.packingMethod,
                fileList: fileList,
                videoList: [],
              };
            });
            this.$store.state.immediateData = Object.assign({
              address: item.address.split(item.areaName)[
                item.address.split(item.areaName).length - 1
              ],
              // areaCode:[item.areaCode],
              areaCode: item.areaCode.split("_").map((i) => {
                areaCode = [...areaCode, i];
                return areaCode.join("_");
              }),
              checkList: [],
              customerName: item.customerName,
              customerPhone: item.customerPhone,
              distance: item.distance,
              floorsNumber: Number(item.floorsNumber),
              goodsTypeId: item.goodsTypeId, // 暂无
              isArrival: item.isArrival.toString(),
              isJishiTihuoFei: item.orderExpand.isJishiTihuoFei,
              isLift: item.isLift.toString(),
              lat: item.lat,
              lng: item.lng,
              logisticsCompany: item.logisticsCompany,
              logisticsNo: item.logisticsNo,
              logisticsPhone: item.logisticsPhone,
              orderItems: orderItems,
              packingCount: item.packingCount,
              pickUpLat: item.orderExpand.pickUpLat,
              pickUpLng: item.orderExpand.pickUpLng,
              pickupAddress: item.pickupAddress.split(item.pickupAreaName)[
                item.pickupAddress.split(item.pickupAreaName).length - 1
              ],
              // pickupAreaCode:[item.orderExpand.pickupAreaCode],
              pickupAreaCode:item.orderExpand.pickupAreaCode?item.orderExpand.pickupAreaCode
                .split("_")
                .map((i) => {
                  pickupAreaCode = [...pickupAreaCode, i];
                  return pickupAreaCode.join("_");
                }):'',
              pickupCarTypeId: item.orderExpand.pickupCarTypeId,
              pickupCode: item.pickupCode,
              pickupTruckTypeData: {},
              remark: item.remark,
              serviceType: item.serviceType, // 暂无
              takeDeliveryFee: item.isNeedTakeDelivery,
              totalVolume: item.totalVolume,
              userName: item.userName,
              userPhone: item.userPhone,
              verifOrderNo: item.verifOrderNo,
              verifType: item.verifType,
            });
            this.$router.push({ name: "speedOrder" });
          }
        });
      }
    },
  }
}